// test479
(479 && 0);
